function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "IMG_Suchelupe",
  transform: "translate(-902.025 -276)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rechteck_285",
  "data-name": "Rechteck 285",
  width: 51,
  height: 38,
  transform: "translate(902.025 276)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_110",
  "data-name": "Ellipse 110",
  transform: "translate(921.025 279)",
  fill: "#fff",
  stroke: "#ffe666",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 11,
  r: 11,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 11,
  r: 10,
  fill: "none"
})), /*#__PURE__*/React.createElement("line", {
  id: "Linie_151",
  "data-name": "Linie 151",
  y2: 20,
  transform: "translate(925.167 296.858) rotate(45)",
  fill: "none",
  stroke: "#ffe666",
  strokeLinecap: "round",
  strokeWidth: 2
}));

function SvgImgSuchelupe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 38,
    viewBox: "0 0 51 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSuchelupe);
export default __webpack_public_path__ + "static/media/IMG_Suchelupe.bb9672e464cfee00fed0ceb3c8179ac4.svg";
export { ForwardRef as ReactComponent };